import MerchantSimbartActivityConfigCategoryApi from '@/api/merchant-simbart-activity-config-category'
import MerchantSimbartActivityConfigGroupApi from '@/api/merchant-simbart-activity-config-group'
import MerchantSimbartActivityConfigGiftApi from '@/api/merchant-simbart-activity-config-gift'
import MerchantSimbartActivityConfigEntryFormApi from '@/api/merchant-simbart-activity-config-entry-form'
import MerchantSimbartActivityCompetitionApi from '@/api/merchant-simbart-activity-competition'
import MerchantSimbartActivityCompetitionStageApi from '@/api/merchant-simbart-activity-competition-stage'
import MerchantSimbartActivityCompetitionStageMatchApi from '@/api/merchant-simbart-activity-competition-stage-match'
import MerchantSimbartActivityCompetitionStageMatchSessionApi from '@/api/merchant-simbart-activity-competition-stage-match-session'
import MerchantSimbartActivityEntryValueApi from '@/api/merchant-simbart-activity-competition-entry-value'
import MerchantSimbartActivityPartnerApi from '@/api/merchant-simbart-activity-competition-partner'
import MerchantSimbartActivityPartnerCommissionApi from '@/api/merchant-simbart-activity-competition-partner-commission'
import MerchantSimbartActivityJoinCompetitionApi from '@/api/merchant-simbart-activity-join-competition'
import MerchantSimbartActivityPromotionCodeApi from '@/api/merchant-simbart-activity-promotion-code'
import MerchantSimbartLiveMediaApi from '@/api/merchant-simbart-live-media'
import MerchantSimbartAdApi from '@/api/merchant-simbart-ad'
import MerchantSimbartDisplayWallApi from '@/api/merchant-simbart-display-wall'
import MerchantSimbartRankingBoardApi from '@/api/merchant-simbart-ranking-board'
const state = {}

const mutations = {}

const actions = {
  /*
    活动分类配置API
  */
  async allActivityConfigCategory({ commit }) {
    const result = await MerchantSimbartActivityConfigCategoryApi.all()
    return result
  },
  async insertActivityConfigCategory({ commit }, data) {
    const result = await MerchantSimbartActivityConfigCategoryApi.insert(data)
    return result
  },
  async updateActivityConfigCategory({ commit }, data) {
    const result = await MerchantSimbartActivityConfigCategoryApi.update(data)
    return result
  },
  async removeActivityConfigCategory({ commit }, id) {
    const result = await MerchantSimbartActivityConfigCategoryApi.remove(id)
    return result
  },
  async enableActivityConfigCategory({ commit }, id) {
    const result = await MerchantSimbartActivityConfigCategoryApi.enable(id)
    return result
  },
  async disableActivityConfigCategory({ commit }, id) {
    const result = await MerchantSimbartActivityConfigCategoryApi.disable(id)
    return result
  },
  /*
    活动组别配置API
  */
  async allActivityConfigGroup({ commit }) {
    const result = await MerchantSimbartActivityConfigGroupApi.all()
    return result
  },
  async insertActivityConfigGroup({ commit }, data) {
    const result = await MerchantSimbartActivityConfigGroupApi.insert(data)
    return result
  },
  async updateActivityConfigGroup({ commit }, data) {
    const result = await MerchantSimbartActivityConfigGroupApi.update(data)
    return result
  },
  async removeActivityConfigGroup({ commit }, id) {
    const result = await MerchantSimbartActivityConfigGroupApi.remove(id)
    return result
  },
  async enableActivityConfigGroup({ commit }, id) {
    const result = await MerchantSimbartActivityConfigGroupApi.enable(id)
    return result
  },
  async disableActivityConfigGroup({ commit }, id) {
    const result = await MerchantSimbartActivityConfigGroupApi.disable(id)
    return result
  },
  /**
   * 报名配置
   */
  async allActivityConfigEntryForm({ commit }) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.all()
    return result
  },
  async getActivityConfigEntryForm({ commit }, id) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.getById(id)
    return result
  },

  /**
   * 克隆配置信息
   */
  async cloneActivityConfigEntryForm({ commit, dispatch }, data) {
    const configId = data.id
    const fields = await dispatch('allActivityConfigEntryFormCustomFields', configId)
    const entryForm = await dispatch('getActivityConfigEntryForm', configId)
    for (const it of fields) {
      it.id = -it.id
      if (it.fieldParent > 0) {
        it.fieldParent = -it.fieldParent
      }
    }

    const insertFormData = { ...entryForm, ...data, id: -1 }
    const result = await MerchantSimbartActivityConfigEntryFormApi.insert(insertFormData)
    await dispatch('batchUpdateActivityConfigEntryFormCustomFields', { configEntryFormId: result.id, fields })

    return result
  },

  async insertActivityConfigEntryForm({ commit }, data) {
    // 默认关闭手机号必填
    if (!data.phoneStatus) {
      data.phoneStatus = 0
    }
    // 默认关闭姓名必填
    if (!data.nameStatus) {
      data.nameStatus = 0
    }
    const result = await MerchantSimbartActivityConfigEntryFormApi.insert(data)
    return result
  },
  async updateActivityConfigEntryForm({ commit }, data) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.update(data)
    return result
  },
  async removeActivityConfigEntryForm({ commit }, id) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.remove(id)
    return result
  },
  async enableActivityConfigEntryForm({ commit }, id) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.enable(id)
    return result
  },
  async disableActivityConfigEntryForm({ commit }, id) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.disable(id)
    return result
  },
  async batchUpdateActivityConfigEntryFormCustomFields({ commit }, data) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.batchUpdateCustomFields(data)
    return result
  },
  async batchRemoveActivityConfigEntryFormCustomFields({ commit }, data) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.batchRemoveCustomFields(data)
    return result
  },
  async allActivityConfigEntryFormCustomFields({ commit }, id) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.allCustomFields(id)
    return result
  },
  async addActivityConfigEntryFormCustomField({ commit }, data) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.addCustomField(data)
    return result
  },
  async updateActivityConfigEntryFormCustomField({ commit }, data) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.updateCustomField(data)
    return result
  },
  async removeActivityConfigEntryFormCustomField({ commit }, params) {
    const result = await MerchantSimbartActivityConfigEntryFormApi.removeCustomField(params.configEntryFormId, params.customFieldId)
    return result
  },
  /**
   * 人气礼物配置
   */
  async allActivityConfigGift({ commit }) {
    const result = await MerchantSimbartActivityConfigGiftApi.all()
    return result
  },
  async insertActivityConfigGift({ commit }, data) {
    const result = await MerchantSimbartActivityConfigGiftApi.insert(data)
    return result
  },
  async updateActivityConfigGift({ commit }, data) {
    const result = await MerchantSimbartActivityConfigGiftApi.update(data)
    return result
  },
  /**
   * 活动赛事管理
   */
  async allBaseInfosActivityCompetition({ commit }) {
    const result = await MerchantSimbartActivityCompetitionApi.allBaseInfos()
    return result
  },
  async listActivityCompetition({ commit }, query) {
    const result = await MerchantSimbartActivityCompetitionApi.list(query)
    return result
  },
  async listRankingBoard({ commit }, query) {
    const result = await MerchantSimbartRankingBoardApi.list(query)
    return result
  },
  async createRankingBoard({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.create(data)
    return result
  },
  async updateRankingBoard({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.update(data)
    return result
  },
  async changeRankingBoardStatus({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.changeStatus(data)
    return result
  },
  async deleteRankingBoard({ commit }, id) {
    const result = await MerchantSimbartRankingBoardApi.remove(id)
    return result
  },
  async selectableRankingBoard({ commit }, query) {
    const result = await MerchantSimbartRankingBoardApi.selectable(query)
    return result
  },
  async validateRankingBoardEntries({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.validateEntries(data)
    return result
  },
  async listRankingBoardEntries({ commit }, params) {
    const result = await MerchantSimbartRankingBoardApi.listEntries(params)
    return result
  },
  async batchHiddenRankingBoardEntries({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.batchHiddenEntries(data)
    return result
  },
  async batchDeleteRankingBoardEntries({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.batchDeleteEntries(data)
    return result
  },
  async addRankingBoardEntriesFromActivity({ commit }, data) {
    const result = await MerchantSimbartRankingBoardApi.addEntriesFromActivity(data)
    return result
  },
  async stackRankingBoardFromRanking({ commit }, payload) {
    const result = await MerchantSimbartRankingBoardApi.stackFromRanking(payload)
    return result
  },
  async getActivityCompetition({ commit }, id) {
    const result = await MerchantSimbartActivityCompetitionApi.getById(id)
    return result
  },
  async insertActivityCompetition({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.insert(data)
    return result
  },
  async updateActivityCompetition({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.update(data)
    return result
  },
  async removeActivityCompetition({ commit }, id) {
    const result = await MerchantSimbartActivityCompetitionApi.remove(id)
    return result
  },
  async quickCreateActivityCompetition({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.quickCreate(data)
    return result
  },
  async getCompetitionShareUrlActivityCompetition({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.getCompetitionShareUrl(data)
    return result
  },
  async allMatchesActivityCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityCompetitionApi.allMatches(params)
    return result
  },
  async getTotalCost({ commit }, params) {
    const result = await MerchantSimbartActivityCompetitionApi.getTotalCost(params)
    return result
  },
  /**
   * 状态变更
   */
  async changeStatus({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.changeStatus(data)
    return result
  },
  async changePublishStatus({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.changePublishStatus(data)
    return result
  },
  async changePlatformShowStatus({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.changePlatformShowStatus(data)
    return result
  },
  async changeContentShowStatus({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionApi.changeContentShowStatus(data)
    return result
  },
  /**
   * 赛程管理
   */
  async allActivityCompetitionStage({ commit }, competitionId) {
    const result = await MerchantSimbartActivityCompetitionStageApi.all(competitionId)
    return result
  },
  async getActivityCompetitionStage({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageApi.getById(data)
    return result
  },
  async insertActivityCompetitionStage({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageApi.insert(data)
    return result
  },
  async updateActivityCompetitionStage({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageApi.update(data)
    return result
  },
  async removeActivityCompetitionStage({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageApi.remove(data)
    return result
  },
  async setProcessingActivityCompetitionStage({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageApi.setProcessingStage(data)
    return result
  },
  /**
   * 展示墙管理
   */
  async getDisplayWallStages({ commit }, competitionId) {
    const result = await MerchantSimbartDisplayWallApi.getStages(competitionId)
    return result
  },
  async saveDisplayWallStages({ commit }, data) {
    const result = await MerchantSimbartDisplayWallApi.saveStages(data)
    return result
  },
  async getDisplayWallEntryPinList({ commit }, params) {
    const result = await MerchantSimbartDisplayWallApi.getEntryPinList(params)
    return result
  },
  async setDisplayWallEntryPin({ commit }, data) {
    const result = await MerchantSimbartDisplayWallApi.setEntryPin(data)
    return result
  },
  async batchSetDisplayWallEntryPin({ commit }, data) {
    const result = await MerchantSimbartDisplayWallApi.batchSetEntryPin(data)
    return result
  },
  /**
   * 获取公开报名列表（展示墙扩展）- 移动端公开接口
   */
  async getPublicEntryValues({ commit }, params) {
    const result = await MerchantSimbartDisplayWallApi.getPublicEntryValues(params)
    return result
  },
  /**
   * 分赛管理
   */
  async allActivityCompetitionStageMatch({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchApi.all(data)
    return result
  },
  async getActivityCompetitionStageMatch({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchApi.getById(data)
    return result
  },
  async insertActivityCompetitionStageMatch({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchApi.insert(data)
    return result
  },
  async updateActivityCompetitionStageMatch({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchApi.update(data)
    return result
  },
  async removeActivityCompetitionStageMatch({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchApi.remove(data)
    return result
  },
  /**
   * 场次管理
   */
  async allActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.all(data)
    return result
  },
  async getActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.getById(data)
    return result
  },
  async insertActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.insert(data)
    return result
  },
  async updateActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.update(data)
    return result
  },
  async removeActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.remove(data)
    return result
  },
  async getEntryValueCountActivityCompetitionStageMatchSession({ commit }, data) {
    const result = await MerchantSimbartActivityCompetitionStageMatchSessionApi.getEntryValueCount(data)
    return result
  },
  /**
   * 合伙人管理
   */
  async listMerchantSimbartActivityPartner({ commit }, params) {
    const result = await MerchantSimbartActivityPartnerApi.list(params)
    return result
  },
  async getPartnerInviteUrlMerchantSimbartActivityPartner({ commit }, params) {
    const result = await MerchantSimbartActivityPartnerApi.getPartnerInviteUrl(params)
    return result
  },
  async getCompetitionInviteUrlMerchantSimbartActivityPartner({ commit }, params) {
    const result = await MerchantSimbartActivityPartnerApi.getCompetitionInviteUrl(params)
    return result
  },
  async changePartnerStatusMerchantSimbartActivityPartner({ commit }, data) {
    const result = await MerchantSimbartActivityPartnerApi.changePartnerStatus(data)
    return result
  },
  async addPartnerMerchantSimbartActivityPartner({ commit }, data) {
    const result = await MerchantSimbartActivityPartnerApi.addPartner(data)
    return result
  },
  async allCommissionsMerchantSimbartActivityPartner({ commit }, params) {
    const result = await MerchantSimbartActivityPartnerCommissionApi.list(params)
    return result
  },
  async saveCommissionMerchantSimbartActivityPartner({ commit }, data) {
    const result = await MerchantSimbartActivityPartnerCommissionApi.save(data)
    return result
  },
  /**
   * 报名表管理
   */
  async listSimbartActivityEntryValue({ commit }, params) {
    const result = await MerchantSimbartActivityEntryValueApi.list(params)
    return result
  },
  /**
   * 获取代报名队员
   * @param {*} param0
   * @param {*} params
   * @returns
   */
  async membersSimbartActivityEntryValue({ commit }, params) {
    const result = await MerchantSimbartActivityEntryValueApi.members(params)
    return result
  },
  async siftOutSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.siftOut(data)
    return result
  },
  async promotionSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.promotion(data)
    return result
  },
  async ratefinishSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.rateFinish(data)
    return result
  },
  async rateListSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.rateList(data)
    return result
  },
  async rateSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.rate(data)
    return result
  },
  async exportExcelSimbartActivityEntryValue({ commit }, params) {
    const result = await MerchantSimbartActivityEntryValueApi.exportExcel(params)
    return result
  },
  async importExcelSimbartActivityEntryValue({ commit }, { formData, competitionId, merchantId }) {
    // 如果传入了 merchantId，需要添加到 FormData 或查询参数中
    // 根据实际 API 需求，可能需要修改 MerchantSimbartActivityEntryValueApi.importExcel
    const result = await MerchantSimbartActivityEntryValueApi.importExcel(formData, competitionId, merchantId)
    return result
  },
  async changeAvailableStatusSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.changeAvailableStatus(data)
    return result
  },
  async changeAuditStatusSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.changeAuditStatus(data)
    return result
  },
  async getSessionMembersSimbartActivityEntryValue({ commit }, params) {
    const result = await MerchantSimbartActivityEntryValueApi.getSessionMembers(params)
    return result
  },
  async resetSessionSimbartActivityEntryValue({ commit }, data) {
    const result = await MerchantSimbartActivityEntryValueApi.resetSession(data)
    return result
  },
  /**
   * 参与的活动
   */
  async listActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.list(params)
    return result
  },
  async detailActivityJoinCompetition({ commit }, id) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.detail(id)
    return result
  },
  async listEntryValueActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listEntryValue(params)
    return result
  },
  async listPartnerActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listPartner(params)
    return result
  },
  async getPartnerActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.getPartner(params)
    return result
  },
  async listGroupActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listGroup(params)
    return result
  },
  async listCategoryActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listCategory(params)
    return result
  },
  async listMatchActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listMatch(params)
    return result
  },
  async listCommissionActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.listCommission(params)
    return result
  },
  async saveCommissionActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.saveCommission(params)
    return result
  },
  async changePartnerStatusActivityJoinCompetition({ commit }, data) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.changePartnerStatus(data)
    return result
  },
  async allStagesActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.allStages(params)
    return result
  },
  async allMatchesActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.allMatches(params)
    return result
  },
  async allSessionsActivityJoinCompetition({ commit }, params) {
    const result = await MerchantSimbartActivityJoinCompetitionApi.allSessions(params)
    return result
  },
  async listPromotionCode({ commit }, params) {
    const result = await MerchantSimbartActivityPromotionCodeApi.list(params)
    return result
  },
  async insertPromotionCode({ commit }, data) {
    const result = await MerchantSimbartActivityPromotionCodeApi.insert(data)
    return result
  },
  async updatePromotionCode({ commit }, data) {
    const result = await MerchantSimbartActivityPromotionCodeApi.update(data)
    return result
  },
  async removePromotionCode({ commit }, id) {
    const result = await MerchantSimbartActivityPromotionCodeApi.remove(id)
    return result
  },
  async listLiveMedia({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.list(params)
    return result
  },
  async insertLiveMedia({ commit }, data) {
    const result = await MerchantSimbartLiveMediaApi.insert(data)
    return result
  },
  async removeLiveMedia({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.remove(params)
    return result
  },
  async removeBatchLiveMedia({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.removeBatch(params)
    return result
  },
  async putWonderfulMomentAudit({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.putWonderfulMomentAuditApi(params)
    return result
  },

  async putWonderfulMomentBatchAudit({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.putWonderfulMomentBatchAuditApi(params)
    return result
  },

  async putWonderfulMomentBatchTop({ commit }, params) {
    const result = await MerchantSimbartLiveMediaApi.putWonderfulMomentBatchTopApi(params)
    return result
  },

  /*
    广告管理
  */
  async addAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.addAd(params)
    return result
  },
  async queryAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.query(params)
    return result
  },
  async editAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.edit(params)
    return result
  },
  async deleteAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.deleteById(params)
    return result
  },
  async enableAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.enable(params)
    return result
  },
  async disableAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.disable(params)
    return result
  },
  async competitionAddAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.competitionAddAd(params)
    return result
  },
  async competitionQueryAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.competitionQueryAd(params)
    return result
  },
  async competitionDeleteAd({ commit }, params) {
    const result = await MerchantSimbartAdApi.competitionDeleteAd(params)
    return result
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/merchant-simbart.js